export default "__VITE_ASSET__Lmd7vEmn__"